/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Dashboard<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Dashboard
   * @name RecordActivityCreate
   * @request POST:/Dashboard/RecordActivity
   * @secure
   */
  recordActivityCreate = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Dashboard/RecordActivity`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * Read-only current/longest streak. Does not record a study day (that happens
   * on genuine study actions: completing a lesson or a quiz).
   *
   * @tags Dashboard
   * @name StreakList
   * @request GET:/Dashboard/Streak
   * @secure
   */
  streakList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Dashboard/Streak`,
      method: "GET",
      secure: true,
      ...params,
    });
}
